import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class News extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    render() {
        const { content } = this.props;

        return (
            <ul className={styles.news}>
                {
                    content.map((item, index) => {
                        return (
                            <li key={index}>
                                <a className={styles.title} href={item.url} target="_blank" rel="noreferrer">{item.title}</a>
                                <span className={styles.time}>[{item.newsTime}]</span>
                            </li>
                        );
                    })
                }
            </ul>
        );

    }
}

export default News;
